/* eslint-disable no-unused-vars */
import { getURLParameterVal } from './../store/helpers';
import { clearThemingColors, setPermeativeElementsTheme, applyForgeAppearance, getObjectsMatchingProperty } from '../utils/forgeUtils'
import { getAttachment, postAttachment } from '../utils/mongoUtils'
import { stopForge, getViewPage3D, getMarkupsComponent } from '../scripts/js/forgeviewer';
const THREE = window.THREE;
import store from '@/store';

export class ForgeMessage {
    constructor(title, data) {
        this.title = title;
        this.data = data;
    }
    clone() {
        var obj = new ForgeMessage();
        obj.title = this.title;
        obj.data = this.data;
        return obj;
    }
    send() {    
        var message = this;
        var messageString = JSON.stringify(message);
        window.top?.postMessage(messageString, '*');
    }
    static sendMessageToParent(title, data){
        var forgeMessage = new ForgeMessage(title, data);
        forgeMessage.send();
    }
}

window.addEventListener('message', (msg) => { onNewMessage(msg) });

export function isParentOrigin() {
    var parent = getURLParameterVal('type');
    if (parent) {
        return parent.includes('origin');
    }
    return false;
}

export function isPermitModule() {
    var parentModuleUrl = getURLParameterVal('moduleUrl') ? getURLParameterVal('moduleUrl', true) : '';
    if(parentModuleUrl) {
        return parentModuleUrl.includes('permit');
    }
}

//Add event listener to incomming messages
export function onNewMessage(messageEvent) {
    var data = messageEvent.data;
    var dataObject;
    try { //check if incoming message is JSON
        dataObject = JSON.parse(data);
    } catch(e) {
        return false;
    }
    var message = Object.assign(new ForgeMessage(), dataObject);
	switch (message.title) {
        case "markups-save-prompt":
            onMarkupsSaving(message.data);
            break;
        case "show-attachment":
            onShowAttachment(message.data);
            break;
        case "add-attachment":
            onAddAttachment(message.data);
            break;
        case "next-test-blind-sequence":
            onNextTestBlindSequence(message.data);
            break;
        case "test-blind-markups":
            onTestBlindMarkups(message.data)
            break;
        case "dispose-forge":
            stopForge();
            break;
        case "show-tags-in-Forge":
            showTagsInForge(message.data);
            break;
        case "open-new-asset":
            store.state.dbidsToLoad = null
            store.state.assetName = message.data.assetName;
            store.state.assetId = message.data.assetId;
            store.state.mainApp.init()
            break;
        case "isolate-workpacks":
            isolateConnectItems(message.data,0,'workPackNumber')
            break;
        case "isolate-completions":
            isolateConnectItems(message.data,1,'name')
            break;
        case "isolate-fabrications":
            isolateConnectItems(message.data, 2, 'name')
            break;
        case "isolate-AMIS-tags":
            isolateAMISTagsFromDashboard(message.data);
            break;
        case "apply-forge-appearance":
            applyAppearanceOnPropertyFilteredElements(message.data)
            break;
        case "tags-activities-response":
            tagsActivitiesResponseHandler(message.data)
            break;
        case "update-amis-selected-units":
            updateAMISSelectedUnits(message.data)
            break;
        case "update-amis-selected-tab":
            updateAMISSelectedTab(message.data)
            break;
        case "update-amis-selected-filter-colors":
            updateAMISSelectedFilterColors(message.data)
            break;
        case "update-activity-tags":
            updateActivityTags(message.data);
            break;
        case "update-activity-number":
            updateActivityNumber(message.data);
            break;
        case "remove-activities":
            removeActivities(message.data);
            break;
        case "update-activity-status-color":
            updateActivityStatusColor(message.data);
            break;
        case "run-activities-timeline":
            runActivitiesTimeline(message.data);
            break;
        case "stop-activities-timeline":
            stopActivitiesTimeline(message.data);
            break;
        case "pause-activities-timeline":
            pauseActivitiesTimeline(message.data);
            break;
        case "resume-activities-timeline":
            resumeActivitiesTimeline(message.data);
            break;
        case "change-activities-timeline-speed":
            changeActivitiesTimelineSpeed(message.data);
            break;
        case "change-timeline-Zoom":
            changeActivitiesTimelineZoom(message.data);
            break;
        case 'ACTIVITY_DETAILS_POPUP_CLOSED':
            updateSisDashboardData();
            break;
        default:
            break;
    }
}

export function updateSisDashboardData() {
    store.dispatch('UPDATE_SIS_DASHBOARD_DATA');
}

export function runActivitiesTimeline(data) {
    if (!getViewPage3D()) {
        store.dispatch({
            type: "alert_Forge",
            message: 'Please open 3d viewer before run activities timeline.'
        });

        ForgeMessage.sendMessageToParent('timeline-ended', {});
        
        return;
    }

    let colors = store.state.activityStatusColor ?? {};

    let activities = data.map(a => {
        return {
            id: a.id,
            startDate: new Date(a.start),
            endDate: new Date(a.end),
            tag: {
                id: a.tag?.guid,
                type: a.tag?.type,
                color: a.runningStageTitle ? colors[a.runningStageTitle] : null
            }
        }
    });

    activities.sort((a, b) => new Date(a.startDate) - new Date(b.startDate));

    store.commit('SET_TIMELINE_DATA', activities);

    store.dispatch('RUN_TIMELINE');
}
export function stopActivitiesTimeline() {
    store.dispatch('STOP_TIMELINE');
}
export function pauseActivitiesTimeline() {
    store.dispatch('PAUSE_TIMELINE');
}
export function resumeActivitiesTimeline() {
    store.dispatch('RESUME_TIMELINE');
}
export function changeActivitiesTimelineSpeed(data) {
    store.dispatch('CHANGE_TIMELINE_SPEED', data.speed);
}
export function changeActivitiesTimelineZoom(data) {
    store.dispatch('CHANGE_TIMELINE_ZOOM', data.shouldZoom);
}


export function updateActivityStatusColor(data) {
    store.state.activityStatusColor = data ?? {};
}

/*
    data: { activities: ["..", ...] }
*/
export function removeActivities(data) {
    let values = data.activities;
    let activities = store.getters['GET_TAGS_ACTIVITIES'];

    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (!value) continue;
        let activityTags = activities.byActivityNumber[value]?.tagsIds ?? [];
        for (let i = 0; i < activityTags.length; i++) {
            const id = activityTags[i];
            activities.byTagId[id] = activities.byTagId[id].filter(t => t != value);
        }
        delete activities.byActivityNumber[value];
    }

    activities.byTagId = { ...activities.byTagId }

    store.commit('SET_TAGS_ACTIVITIES', { ...activities });
}

/*
    updatedActivityNumber = { newActivityNumber: ..., oldActivityNumber: ... }
*/
export function updateActivityNumber(updatedActivityNumber) {
    const current = updatedActivityNumber.newActivityNumber;
    const old = updatedActivityNumber.oldActivityNumber;

    let activities = store.getters['GET_TAGS_ACTIVITIES'];
    let oldActivity = activities.byActivityNumber[old] ?? {};
    let activityTags = oldActivity?.tagsIds ?? []; 

    activities.byActivityNumber[current] = {
        ...oldActivity,
        subJobNumber: current
    };

    delete activities.byActivityNumber[old];

    for (let i = 0; i < activityTags.length; i++) {
        const t = activityTags[i];
        activities.byTagId[t] = activities.byTagId[t].map((val) => (val === old ? current : val));
    }

    activities.byTagId = { ...activities.byTagId }

    store.commit('SET_TAGS_ACTIVITIES', { ...activities });
}

/*
    activity = { id: .., assetId : .., activityNumber: .., mainTag : .., secondaryTags: [...] };
*/
export function updateActivityTags(activity) {
    let activities = store.getters['GET_TAGS_ACTIVITIES'];

    let ac = activity.activityNumber;

    let currentRelatedTags = [activity.mainTag?.guid, ...activity.secondaryTags.map(t => t.guid)].filter(t => !!t);

    let oldActivity = activities.byActivityNumber[ac] ?? {};
    let oldRelatedTags = [...oldActivity?.tagsIds ?? []];

    let currentActivity = {
        ...oldActivity,
        tagsIds: currentRelatedTags
    }

    activities.byActivityNumber[ac] = currentActivity;

    for (let i = 0; i < oldRelatedTags.length; i++) {
        const id = oldRelatedTags[i];
        activities.byTagId[id] = activities.byTagId[id].filter(t => t != ac);
    }

    for (let i = 0; i < currentRelatedTags.length; i++) {
        const id = currentRelatedTags[i];

        if (!activities.byTagId[id]?.length) activities.byTagId[id] = [];

        activities.byTagId[id].push(ac);
    }

    activities.byTagId = { ...activities.byTagId }

    store.commit('SET_TAGS_ACTIVITIES', { ...activities });
}

export function updateAMISSelectedFilterColors(data) {
    let indices = data?.filtersIndices;

    if (!indices) return;
    
    if (!indices.length) {
        store.dispatch('UPDATE_AVAILABLE_FILTERS_COLORS', () => {
            store.state.TAGS.selectedColorOptions =  [] //[...store.state.TAGS.InspectionAvailableColorOptions];
        });
    } else {
        let options = [];
        
        for (let i = 0; i < indices.length; i++) {
            let index = indices[i];
            if (index == '-1') index = store.state.TAGS.InspectionAvailableColorOptions.length - 1;
            let value = store.state.TAGS.InspectionAvailableColorOptions[index];
            if (value) options.push(store.state.TAGS.InspectionAvailableColorOptions[index]);
        }
        
        store.state.TAGS.selectedColorOptions = [...options];
        store.state.forgeService.loadAMISTagsAdvanced(store.state.TAGS.amisSearchText, true);        
    }
}

export function updateAMISSelectedTab(data) {
    let tab = data?.tab;
    if (!tab) return;
    let map = {
        'rt': "Remaining Thickness",
        'rl': "Remaining Life",
        'cr': "Corrosion Rate",
    }
    if (store.state.inspections.length > 0) map["ispDateDays"] = "Inspection Plan";
    if (!!map[tab] && store.state.TAGS.InspectionSelectedFilter != map[tab]) {
        store.state.TAGS.InspectionSelectedFilter = map[tab];
        store.dispatch('UPDATE_AVAILABLE_FILTERS_COLORS');
    }
}

export function updateAMISSelectedUnits(data) {
    if (data.length) {
        store.getters['GET_AMIS_UNITS'].forEach(u => {
            u.isChecked = data.includes(u.name);
        });
    } else {
        store.getters['GET_AMIS_UNITS'].forEach(u => {
            u.isChecked = true;
        });
    }
    store.dispatch('UPDATE_AVAILABLE_FILTERS_COLORS');
    store.state.forgeService.loadAMISTagsAdvanced(store.getters["GET_AMIS_SEARCH_TEXT"], true);
}

export function isolateAMISTagsFromDashboard(data) {
    if (!store.state.viewer || !store.state.viewer.model || !data) return;

    let { mode, tagsIds } = data;

    let manualInspections = store.state.inspections?.filter(o => tagsIds.includes(o.id)) ?? [];
    var fetchedInspections = store.state.TAGS.allExistingAMISDbids?.filter(o => tagsIds.includes(o.id)) ?? [];
    let inspections = fetchedInspections.concat(manualInspections)

    if (inspections.length == 0) {
        store.dispatch("alert_Forge", { message: `No inspections found with the filtered items.` });
        return;
    }

    let tree = store.state.viewer?.model?.getInstanceTree();

    if (!tree) {
        store.dispatch('alert_Forge', {
            message: 'Model not loaded yet.'
        });
        return;
    }

    let InspectionSelectedFilter = store.state.TAGS.InspectionSelectedFilter;
    let selectedColorsOptions = [];
    let targetProperty = '';

    if (InspectionSelectedFilter == "Remaining Thickness") {
        selectedColorsOptions = store.state.TAGS.InspectionThickPlanColorOptions;
        targetProperty = 'rt';
    } else if (InspectionSelectedFilter == "Remaining Life") {
        selectedColorsOptions = store.state.TAGS.InspectionRemainingLifeColorOptions;
        targetProperty = 'rl';
    }
    else if (InspectionSelectedFilter == "Corrosion Rate") {
        selectedColorsOptions = store.state.TAGS.InspectionCorrRateColorOptions;
        targetProperty = 'cr';
    }
    else if (InspectionSelectedFilter == "Inspection Plan") {
        selectedColorsOptions = store.state.TAGS.InspectionPlanColorOptions;
        targetProperty = 'ispDateDays';
    }

    let themedDbIds = store.getters['GET_THEMED_DB_IDS'];
    let needToReset = store.state.isGhostingOn && !store.state.isGhostingWireframe

    if (!!themedDbIds?.length && needToReset) clearThemingColors(store.state.viewer);

    let dbIdsAMIS = [];

    inspections.forEach(tag => {
        let dbIds = tag.children.map(t => t.dbId) ?? [];
        dbIdsAMIS.push(...dbIds);

        if (selectedColorsOptions) {
            let color = store.state.forgeService.getAMISTagColor(tag, selectedColorsOptions, targetProperty, null);

            if (color) {
                color = new THREE.Color(color);
                color = new THREE.Vector4(color.r, color.g, color.b, 1);
                setPermeativeElementsTheme(dbIds, color);
            }
        } 
    });

    store.commit('SET_THEMED_DB_IDS', dbIdsAMIS);

    store.state.forgeService.getMainExtension().isolateDbIds(dbIdsAMIS, store.state.viewer.model);
}

export function isolateConnectItems(items, index) {
    var colors = {};
    if (index == 0) {//workpack colors
        colors = {
            'Not Started': 0Xa7a7a7,
            'In Progress': 0Xf7a000,
            'In Execution': 0Xffff00,
            'Executed': 0X80c67c,
            'Issued': 0X598fd8,
            'In Review': 0Xad5087,
        }
    } else if (index == 1) {//completions colors
        colors = {
            'Not Started': 0Xa7a7a7,
            'In Progress': 0Xf7a000,
            'Complete': 0X80c67c,
            'Executed': 0X80c67c,
            'Overdue': 0XFF0000,
        }
    } else if (index == 2) {//fabrication colors
        colors = store.state.activityStatusColor ?? {};

        // colors = {
        //     'Not Started': 0X404040,
        //     'Fabrication': 0Xc55a11,
        //     'Blast & Paint': 0Xbf9000,
        //     'Shipping': 0X9dc3e6,
        //     'Paused': 0Xa6a6a6,
        //     'Awaiting Material': 0X8497b0,
        //     'Awaiting Materials': 0X8497b0,
        //     'Cut': 0X548235,
        //     'DC': 0Xac4e86,
        //     'Fit Up': 0X6633cc,
        //     'Weld': 0Xf46c12,
        //     'NDE': 0X2e75b6,
        //     'Hydro': 0X4aaee3,
        //     'Coating': 0X8ccecd,
        //     'Final Inspection': 0Xe1e100,
        //     'Complete': 0X80c67d,
        //     //
        //     'Engineering Drawings': 0XF9F67E,
        //     'Work Pack Issued': 0X41C777,
        //     'Materials Available': 0X37DE2A,
        //     'Construction Ready': 0X431BED,
        //     'MC Complete': 0XA16799,
        //     'Installed': 0X77B157,
        //     'System H/O': 0X107EF8,
        //     'Close out': 0X7227E1,
        //     'DC-Survey': 0XFF6D77,
        //     'Materials Onsite': 0X98FEB0,
        //     'In Progress': 0XFF9609,
        //     //
        //     'Install': 0XDADF1F,
        //     'Terminate / Test': 0XEE9410,
        //     'Inspect': 0X2787D7,
        //     'Accept': 0X38C646,
        //     'Trim/Misc. Valves': 0XAA54AC,
        //     'Test': 0XCF882F,
        //     'A22080': 0XFFE119,
        //     'A22090': 0XF58231,
        //     'A22100': 0X469990,
        //     'A22150': 0XDCBEFF,
        //     'A22110': 0XFFD8B1,
        //     'A22120': 0XFFFAC8,
        //     'A22130': 0X800000,
        //     'A22140': 0X3CB44B,
        // }
    }

    var comingProperty = index == 0 ? 'workpack' : 'name'
    var InternalProperty = index == 0 ? 'workPackNumber' : 'name'

    let workPacks = items.map(o => o[comingProperty])

    var normalEquipments = store.state.tags.filter(o => workPacks.includes(o[InternalProperty])).map(t => {
        return {
            id: t.id,
            [InternalProperty]: t[InternalProperty],
            dbIds: t.getAllDbIds() ?? []
        }
    })

    var automaticEquipments = store.state.TAGS.allExistingAutomaticDbids.filter(o => workPacks.includes(o[InternalProperty])).map(t => {
        return {
            id: t.id,
            [InternalProperty]: t[InternalProperty],
            dbIds: [t.dbid]
        }
    })

    let relatedEquipments = [...normalEquipments, ...automaticEquipments];

    if (relatedEquipments.length == 0) {
        store.dispatch("alert_Forge", {
            message: `No equipments found with the filtered items.`
        });
        return;
    }    

    let tree = store.state.viewer?.model?.getInstanceTree();

    if (!tree) {
        store.dispatch('alert_Forge', {
            message: 'Model not loaded yet.'
        });
        return;
    }

    var allDbIds = relatedEquipments.flatMap(o => o.dbIds)
    
    store.state.forgeService.getMainExtension().isolateDbIds(allDbIds)

    store.commit('SET_THEMED_DB_IDS', allDbIds);

    relatedEquipments.forEach(tag => {
        let targetItem = items.find(o => o[comingProperty] == tag[InternalProperty]);
        let color = colors[targetItem?.progress];
        color = new THREE.Color(color);
        color = new THREE.Vector4(color.r,color.g,color.b, 1);
        let dbIds = tag.dbIds;
        setPermeativeElementsTheme(dbIds, color);
    })

}

export function onMarkupsSaving(data) {
    let markupsComponent = store.state.markupsComponent;

    if(!markupsComponent || !markupsComponent?.onSave) { //Viewer not loaded Correctly
        ForgeMessage.sendMessageToParent('markupsPopupClosed', null)
        ForgeMessage.sendMessageToParent('markups-popup-closed', null)
        ForgeMessage.sendMessageToParent('markups-not-saved', null)
        return;
    }
    var isClosing = data.isClosing;
    markupsComponent.onSave(isClosing, ()=>{
        var _markupsComponent = markupsComponent ? markupsComponent : getMarkupsComponent();
        if(_markupsComponent.markupViewer) {
            _markupsComponent.markupViewer.finish();
            _markupsComponent.markupViewer = null;
        }
        _markupsComponent.hidePopup();
        var savedMessage = new ForgeMessage("markups-saved", null);
        savedMessage.send();
    })
}

export function onAddAttachment(data) {
    var attachment = data;
    postAttachment(attachment);
}

export async function onShowAttachment(data){
    var id = data.id;
    var attachment = await getAttachment(id);
    var attachmentUrl = data.url;
    attachment.url = window.top.location.origin + attachmentUrl;
    store.state.markupsComponent.showAttachment(attachment, true, 1);
}

export function onNextTestBlindSequence(data) {
    var nextSequence = data;
    store.commit('setNextTestBlindSequence', nextSequence);
}

export function onTestBlindMarkups(data){
    store.commit('setTestBlindMarkups', data);
}

export function applyAppearanceOnPropertyFilteredElements(data) {
    if (data == null) return;

    var property = data.property;
    var values = data.values;
    var options = data.forgeAppearanceOptions;
    var viewer = store.state.viewer;

    getObjectsMatchingProperty([], viewer, property, values, true, function (data) {
        var dbIds = data.map(d => d.dbId);
        applyForgeAppearance(viewer, viewer.model, dbIds, options)
    });
}

export function tagsActivitiesResponseHandler(data) {
    const activities = {
        byActivityNumber: {},
        byTagId: {}
    };

    data.forEach(activity => {
        const relatedTagsIds = [activity.primaryTag?.tagId, ...activity.secondaryTags.map(t => t.tagId)];

        activities.byActivityNumber[activity.subJobNumber] = {
            ...activity,
            tagsIds: relatedTagsIds
        }

        relatedTagsIds.forEach(tagId => {
            if (!activities.byTagId[tagId]) activities.byTagId[tagId] = [];
            activities.byTagId[tagId].push(activity.subJobNumber);
        });
    });

    store.commit('SET_TAGS_ACTIVITIES', activities);
}

export function showTagsInForge(data) {
    let currentActivityManagerViewIndex = store.state.activityManagerViewIndex;

    if (currentActivityManagerViewIndex === 0) {
        let isTabShown = store.state.isTabShown;
        // Half width view index = 1
        store.state.activityManagerViewIndex = 1;
        ForgeMessage.sendMessageToParent('toggle-activity-manager', { 
            showActivityManager: true,
            viewIndex: 1,
            fullWidth: !isTabShown
        });
    }

    store.state.forgeService.showTagsByIds(data);
}

// if(isParentOrigin()) {
//     $(document).ready(export function () {
//         var forgeMessage = new ForgeMessage('get-next-test-blind-sequence', null);
//         forgeMessage.send();
//     });
// }
